module.exports = __webpack_public_path__ + "static/media/order-empty.ae59ca13.svg";